import { writable } from "svelte/store";

export const accountInfo = writable(null);
export const jwt_token = writable(null);
export const refreshToken = writable(null);
export const fcm_token = writable("");
export const theme = writable("light"); 
export const selectedAs = writable(null); // 선택된 AS 요청 정보 저장용export const selectedAs = writable(null); // 선택된 AS 요청 정보 저장용

export const asListState = writable({
    isSearchHidden: false,
    scrollTop: 0,
    selectedStatus: "1",
    searchType: "all",
    searchKeyword: "",
    startDate: null,
    endDate: null,
    activeStatus: "1",
    activeSearchType: "all",
    activeKeyword: "",
    activeStartDate: null,
    activeEndDate: null
});

// export function resetAsStore() {
//     asStore.set(asState());
// }
